// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"NotFound_layoutBox__1ni8T","center":"NotFound_center__OfkYr","title":"NotFound_title__zMMCl","flexList":"NotFound_flexList__1cZGV"};